// https://vuex.vuejs.org/en/actions.html

import NewApiService from "@/utils/new.api.service";

export default {
  index(context, params) {
    const { sortBy, descending, page, rowsPerPage } = params.pagination
      ? params.pagination
      : [null, null, null, null];
    context.commit("set_loading");
    return new Promise(resolve => {
      NewApiService.get("accounts/list", {
        page: page,
        sortBy: sortBy,
        descending: descending,
        rowsPerPage: rowsPerPage,
        search: params.search,
        locationId: params.locationId
      })
        .then(({ data }) => {
          context.commit("set_accounts", data);
          context.commit("unset_loading");
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit("set_error", response.data.errors);
        });
    });
  },
  get(context) {
    context.commit("set_loading");
    return new Promise((resolve, reject) => {
      NewApiService.get("accounts")
          .then(({ data }) => {
            context.commit("unset_loading");
            context.commit("set_account", data);
          })
          .catch(({ response }) => {
            reject(response.data.errors);
          });
    });
  },
  getList(context) {
    context.commit("set_loading");
    return new Promise((resolve, reject) => {
      NewApiService.get("accounts/list")
          .then(({ data }) => {
            context.commit("unset_loading");
            context.commit("set_accounts", data);
          })
          .catch(({ response }) => {
            reject(response.data.errors);
          });
    });
  },
  switchAccount(context, id) {
    context.commit("set_loading");
    return new Promise((resolve, reject) => {
      NewApiService.put("accounts/switch", {id})
          .then(({ data }) => {
            context.commit("unset_loading");
            context.commit("set_account", data);
            resolve(data)
          })
          .catch(({ response }) => {
            reject(response.data.errors);
          });
    });
  },
  add(context, params) {
    context.commit("set_loading");
    return new Promise(resolve => {
      NewApiService.post("accounts", params.model)
        .then(({ data }) => {
          context.commit("unset_loading");
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit("set_error", response.data.errors);
        });
    });
  },
  update(context, params) {
    context.commit("set_loading");
    return new Promise(resolve => {
      NewApiService.put("accounts/" + params.model.id, params.model)
        .then(({ data }) => {
          context.commit("unset_loading");
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit("set_error", response.data.errors);
        });
    });
  }
};
